import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
  templateUrl: './add-notes-comments.component.html'
})
export class AddNotesCommentsComponent {
  title: string;
  consignmentNoteNumber: string;
  comments: string;
  isLoading: boolean;
  isUpdating: boolean;
  proceed: boolean;
  commandId: number;
  public postingDate: Date;

  constructor(private matDialogRef: MatDialogRef<AddNotesCommentsComponent>,
              private router: Router,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = data.title;
    this.isLoading = false;
    this.proceed = false;
    this.isUpdating = false;
    this.consignmentNoteNumber = '';
    this.comments = '';
    this.commandId = this.data.id;
  }

  close(value?) {
    this.matDialogRef.close(value);
  }

  isDisabled() {
    return !this.consignmentNoteNumber || !this.comments || !this.postingDate;
  }

  async completeCommand() {
    try {
      const isDateValid = this.checkPostingDate();
      if (isDateValid) {
        this.matDialogRef.close({
          consignment_note_number: this.consignmentNoteNumber,
          comments: this.comments,
          posting_date: this.postingDate
        });
      } else {
        this.toastMessagesService.toastMessages(`Μη έγκυρη ημερομηνία.`);
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isUpdating = false;
    }
  }

  checkPostingDate() {
    // postingDate: ο μήνας πρέπει να είναι ο τρέχων ή ένας προηγούμενος.
    const selectedMonth = this.postingDate.getMonth() + 1;
    const currentMonth = new Date().getMonth() + 1;
    return (currentMonth === selectedMonth || selectedMonth === currentMonth - 1);
  }
}
